/* eslint-disable no-useless-catch */
import { client } from './client'

const verifyEmail = async (id, secret) => {
  try {
    const url = '/v1/emailverification'

    await client.put(url, { id, secret })
  } catch (error) {
    throw error
  }
}

const submitOTP = async (payload) => {
  try {
    const url = '/v1/auth/signin-web/sms'
    const data = await client.put(url, payload)
    return data
  } catch (error) {
    throw error
  }
}

const getOTP = async (payload) => {
  try {
    const url = '/v2/auth/signup/signin/sms'
    await client.post(url, payload)
  } catch (error) {
    throw error
  }
}

const supplyUserDetails = async (payload, accessToken) => {
  try {
    const url = '/v1/web-signup/users'

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` }
    }

    await client.post(url, payload, config)
  } catch (error) {
    throw error
  }
}

const getUserDetails = async (accessToken) => {
  try {
    const url = '/v1/web-signup/users'

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` }
    }

    const data = await client.get(url, config)
    return data
  } catch (error) {
    throw error
  }
}

export {
  verifyEmail,
  submitOTP,
  getOTP,
  supplyUserDetails,
  getUserDetails
}
